export const LOCAL = 'localhost';
export const LEAVE_WEBSITE_ACTION = 'leave';
export const ENTER_WEBSITE_ACTION = 'enter';
